/**
 * Converts a JSON object to FormData.
 * When this FormData is sent via HTTP:
 * - The browser automatically adds a boundary (e.g. ----WebKitFormBoundary...)
 * - Each field is separated by this boundary
 * - Content-Disposition headers are automatically added for each field
 * - The final boundary has -- at the end
 * 
 * @param data - Object containing key-value pairs to convert to FormData
 * @returns FormData object ready to be sent to the server
 */
export const jsonToFormData = (data: Record<string, string>): FormData => {
    const formData = new FormData();
    
    Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
    });

    return formData;
};